/* eslint-disable react-hooks/rules-of-hooks */
import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

/**
 * 解析 reqMetrics 配置，支持两种格式：
 * - 数组: ["a","b"] → 所有粒度通用
 * - 对象: { Day: ["a"], Week: ["b"], Month: ["c"] } → 按粒度
 */
const getReqMetricsByTimeType = (reqMetrics: string[] | Record<string, string[]> | undefined, timeType: string): string[] | undefined => {
  if (!reqMetrics) return undefined;
  if (Array.isArray(reqMetrics)) return reqMetrics;
  return reqMetrics[timeType] || reqMetrics.Day || undefined;
};

interface IDateComparisonRequestParams {
  ct_end_time: string;
  ct_start_time: string;
  filters: Record<string, unknown>;
  game_code: string;
  period: string;
  st_end_time: string;
  st_start_time: string;
  metric?: string;
  metrics?: string[];
}

export default function dateComparisonTrendService(props: any) {
  const { style, className, type, config, children, data: propsData, extraParams = {}, reqMetrics: propsReqMetrics, ...resetProps } = props || {};
  const { api, refreshKey = '', dataKey = '', interval } = config || {};
  // 优先从 props.reqMetrics 读，fallback 到 data.reqMetrics（统一配置在外层 data 中）
  const reqMetrics = propsReqMetrics || propsData?.reqMetrics;
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    ...(propsData || {})
  }), [gameCode, propsData]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        interval={interval}
        dataKey={dataKey || 'keyMetricsData'}
        beforeRequest={(data) => {
          const { filterVal, gameCode, metrics, dataFrame } = data;
          const { timeType, diff, rangeTime, contrastDate, statisticDate, statisticDate_timeType, selector, ...filters } = filterVal || {};
          const params: IDateComparisonRequestParams = {
            ct_end_time: contrastDate?.[1] || '',
            ct_start_time: contrastDate?.[0] || '',
            filters: formatFilterValues(filters),
            game_code: gameCode,
            period: statisticDate_timeType ? PERIODTIMEOBJ[statisticDate_timeType] : 'daily',
            st_end_time: statisticDate?.[1] || '',
            st_start_time: statisticDate?.[0] || '',
          };

          if (dataKey === 'nightingaleRentation') {
            const newParams = {
              ...params,
              ct_end_time: contrastDate || '',
              ct_start_time: contrastDate || '',
              st_end_time: statisticDate || '',
              st_start_time: statisticDate || '',
              metric: filterVal.metric,
              retention_type: metrics.metric_key,
              page: 1,
              page_size: 10000,
              desc: true,
              sort_by: "date"
            };
            return newParams;
          }

          if (dataFrame === "pc_inflextion") {
            params.metric = metrics.metric_key;
          }

          const metricsList = getReqMetricsByTimeType(reqMetrics, statisticDate_timeType || timeType);
          if (metricsList) {
            params.metrics = metricsList;
          }
          return { ...params, ...extraParams };
        }}
        trackData={['gameCode', 'metrics', 'dataFrame']}>
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...resetProps,
            state: {}
          }
        ))}
      </Service>
    </div>
  );
};
